import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatbotTriggerService {
  private trigger = new Subject<void>();

  $triggerEvent = this.trigger.asObservable();

  openChatbot() {
    this.trigger.next();
  }
}
